import axios from 'axios'
import { backendUrl } from '@/helpers/backendUrl.js'
import vuecookie from 'vue-cookies'

const state = {
    endUsers: [],
    protectedUser: null,
    emailForm: {},
    adminUsers: [],
    availableUserLevels: [],
    existingUser: null
}

const getters = {
    getCustomerEndUsers: (state) => state.endUsers,
    getProtectedUser: (state) => state.protectedUser,
    getEmailForm: (state) => state.emailForm,
    getAdminUsers: (state) => state.adminUsers,
    getAvailableUserLevls: (state) => state.availableUserLevels,
    getExistingUser: (state) => state.existingUser
}

const actions = {
    async getEndUsersList( context, data){
        await axios.get(`${backendUrl()}/getEndUsersList`,
        {
            params: {
                page: data.page,
                per_page: data.per_page,
                customerReference: data.customerReference,
                customerName: data.customerName,
                userEmail: data.userEmail,
                userName: data.userName,
                userProtected: data.userProtected,
                userLocked: data.userLocked
            },
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        })
        .then(response => {
            context.commit('setCustomerEndUsers', response.data)
        })
    },
    async getProtectedUser( context, data){
        await axios.get(`${backendUrl()}/getProtectedUser`,
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        })
        .then(response => {
            context.commit('setProtectedUser', response.data)
        })
    },
    async updateEndUser( context, data){
        await axios.post(`${backendUrl()}/updateEndUser`,
        {
            userId: data.userId,
            name: data.name,
            email: data.email,
            level: data.level,
            password: data.password,
            protectedUser: data.protectedUser,
            headUser: data.headUser,
            hashLogon: data.hashLogon,
            currentUser: data.currentUser
        },
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        })
        .then(response => {
            context.dispatch('handleResponse', response, {root: true})
            if(response.data.status == 'error' &&  response.data.key == 'endUserInvalidError'){
                context.commit('setValidationErrors',response.data.errors, {root: true})
            } else {
                context.commit('alertClearErrors', null, {root: true})
            }
        })
    },
    async sendEmailToUser( context, data){
        await axios.post(`${backendUrl()}/sendEmailToUser`,
        {
            userId: data.userId,
            sendTo: data.sendTo,
            from: data.from,
            subject: data.subject,
            password: data.password,
            message: data.message,
            component: data.component
        },
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        })
        .then(response => {
            context.dispatch('handleResponse', response, {root: true})
            if(response.data.status == 'error' &&  response.data.key == 'endUserInvalidError'){
                context.commit('setValidationErrors',response.data.errors, {root: true})
            } else {
                context.commit('alertClearErrors', null, {root: true})
            }
        })
    },    
    async deleteEndUser( context, data ) {
        await axios.post(`${backendUrl()}/deleteEndUser`,
        {
            userId: data.userId,
            currentUser: data.currentUser
        },
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        })
        .then(response => {
            context.dispatch('handleResponse', response, {root: true})
        })
    },
    async updateAccountStatus( context, data ) {
        await axios.post(`${backendUrl()}/updateAccountStatus`, 
        {
            userId: data.userId,
            accountStatus: data.account_disabled,
            currentUser: data.currentUser
        },
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        })
        .then(response => {
            context.dispatch('handleResponse', response, {root: true})
        })
    },
    async getEndUserEmailDetails( context, data ) {
        await axios.get(`${backendUrl()}/getEndUserEmailDetails`,
        {
            params: {
                userId: data.id
            },
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        })
        .then(response => {
            context.commit('setEndUserEmailForm', response.data)
        })
    },
    async getAdminUsersList( context, data ) {
        await axios.get(`${backendUrl()}/getAdminUsersList`,
        {
            params: {
				currentUserLevel: data.currentUserLevel,
                page: data.page,
                per_page: data.per_page,
                email: data.email,
                userLevel: data.userLevel
            },
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        })
        .then(response => {
            context.commit('setAdminUsers', response.data)
        })
    },
    async getAddAdminUserData( context, data ) {
        await axios.get(`${backendUrl()}/getAddAdminUserData`,
        {
            params: {
				userLevel: data.userLevel
            },
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        })
        .then(response => {
            context.commit('setAvailableUserLevls', response.data)
        })
    },
    async addAdminUser( context, data) {
        await axios.post(`${backendUrl()}/addAdminUser`, 
        {
            userName: data.userName,
            name: data.name,
            email: data.email,
            password: data.password,
            userLevel: data.userLevel,
            headUser: data.headUser,
            currentUser: data.currentUser
        },
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        })
        .then(response => {
            
            if(response.data.existingUser) {
                context.commit('setExistingUser', response.data.existingUser)
            }
            context.dispatch('handleResponse', response, {root: true})
            if(response.data.status == 'error' &&  response.data.key == 'adminUserInvalidError'){
                context.commit('setValidationErrors',response.data.errors, {root: true})
            } else {
                context.commit('alertClearErrors', null, {root: true})
            }            
        })
    },
    async updateAdminUserLevel( context, data ) {
        await axios.post(`${backendUrl()}/updateAdminUserLevel`,
        {
            userId: data.userId,
            userLevel: data.userLevel
        },
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        })
        .then(response => {
            context.dispatch('handleResponse', response, {root: true})
        })
    },
    async editAdminUser( context, data){
        await axios.post(`${backendUrl()}/editAdminUser`,
        {
            userId: data.userId,
            name: data.name,
            email: data.email,
            level: data.level,
            password: data.password,
            protectedUser: data.protectedUser,
            headUser: data.headUser,
            hashLogon: data.hashLogon,
            currentUser: data.currentUser
        },
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        })
        .then(response => {
            context.dispatch('handleResponse', response, {root: true})
            if(response.data.status == 'error' &&  response.data.key == 'adminUserInvalidError'){
                context.commit('setValidationErrors',response.data.errors, {root: true})
            } else {
                context.commit('alertClearErrors', null, {root: true})
            }
        })
    },
    async updateAdminAccountStatus( context, data ) {
        await axios.post(`${backendUrl()}/updateAdminAccountStatus`, 
        {
            userId: data.userId,
            accountStatus: data.account_disabled,
            currentUser: data.currentUser
        },
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        })
        .then(response => {
            context.dispatch('handleResponse', response, {root: true})
        })
    },
    async deleteAdminUser( context, data ) {
        await axios.post(`${backendUrl()}/deleteAdminUser`, 
        {
            userId: data.userId,
            currentUser: data.currentUser
        },
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        })
        .then(response => {
            context.dispatch('handleResponse', response, {root: true})
        })
    },
    // NS-9847, function to get user levels for filtering, PW
    async getFilterUserLevels( context, data ) {
        return await axios.post(`${backendUrl()}/getFilterUserLevels`, null,
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        })
        .then(response => {
            return response.data
        })
    },
    // NS-10020 Get the list of principals for admin user
    async getUsersPrincipals( context, data ) {
        return await axios.get(`${backendUrl()}/getUsersPrincipals`,
        {
            params: {
				userId: data.userId
            },
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        })
        .then(response => {
            return response.data
        })
    },
    // NS-10020 get document View access for client
    async getDocViewAccessServiceAndPrincipleTerm( context, data ) {
        return await axios.get(`${backendUrl()}/getDocViewAccessServiceAndPrincipleTerm`,
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        })
        .then(response => {
            return response.data
        })
    },
    // NS-10020 get document types for admin users
    async getAdminDocumentTypes( context, data ) {
        return await axios.get(`${backendUrl()}/getAdminDocumentTypes`,
        {
            params: {
				userId: data.userId
            },
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        })
        .then(response => {
            return response.data
        })
    },
    // NS-10020 update document type access view
    async updateAdminDocTypes( context, data ) {
        await axios.post(`${backendUrl()}/updateAdminDocTypes`, 
        {
            docTypes: data.docTypes,
            userId: data.userId
        },
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        })
        .then(response => {
            context.dispatch('handleResponse', response, {root: true})
        })
    },
    // NS-10020 update admin users principals
    async updateAdminPrincipals( context, data ) {
        await axios.post(`${backendUrl()}/updateAdminPrincipals`, 
        {
            principals: data.principals,
            panPrincipleAccess: data.panPrincipleAccess,
            userId: data.userId
        },
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        })
        .then(response => {
            context.dispatch('handleResponse', response, {root: true})
        })
    },
    
    
}

const mutations = {
    setCustomerEndUsers: (state, endUsers) => (state.endUsers = endUsers),
    setProtectedUser: (state, protectedUser) => (state.protectedUser = protectedUser),
    setEndUserEmailForm: (state, emailForm) => (state.emailForm = emailForm),
    setAdminUsers: (state, adminUsers) => (state.adminUsers = adminUsers),
    setAvailableUserLevls: (state, availableUserLevels) => (state.availableUserLevels = availableUserLevels),
    setExistingUser: (state, existingUser) => (state.existingUser = existingUser)
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}